<template>
  <div class="video-item" v-show="loaded" @click.stop="jumpVideoDetail">
    <div class="content">
      <div class="image-content" v-if="videoData.pics">
        <img
          @load="bindload"
          class="video-image"
          :src="videoData.pics || defaultImage"
        />
      </div>
      <div class="mask">
        <div class="collect" @click.stop="collect">
          <span
            class="iconfont icon-shixinxingxing"
            :class="{ 'iconfont-active': videoData.is_save === 0 }"
          ></span>
          <span>收藏</span>
        </div>
        <div class="use">
          <span>被引用：</span><span>{{ videoData.num || 0 }}</span>
        </div>
      </div>
    </div>
    <div class="desc">{{ videoData.title }}</div>
    <div class="tag-list">
      <div class="tag-item" v-show="videoData.keyword1">
        {{ videoData.keyword1 }}
      </div>
      <div class="tag-item" v-show="videoData.keyword2">
        {{ videoData.keyword2 }}
      </div>
      <div class="tag-item" v-show="videoData.keyword3">
        {{ videoData.keyword3 }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        {
        }
      }
    }
  },
  data() {
    return {
      videoData: {},
      defaultImage: '',
      loaded: false
    }
  },
  created() {
    this.videoData = this.data
  },
  methods: {
    bindload() {
      this.loaded = true
    },
    jumpVideoDetail() {
      let params = {
        id: this.data.id
      }
      this.$router.push({
        path: '/fatcamp/knowledge-base/video-detail',
        query: params
      })
    },
    collect() {
      let active = this.videoData.is_save === 0 ? true : false
      let params = {
        tid: this.videoData.id,
        type_0: this.videoData.type_id,
        type: active ? 2 : 1
      }
      this.$http
        .postApp('member/StorageLogin/optSave', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.videoData.is_save = active ? 1 : 0
            let tips = ''
            if (this.videoData.is_save === 0) {
              tips = '收藏成功'
            } else {
              tips = '取消收藏'
            }
            this.$toast(tips)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.video-item {
  background-color: #fff;
  overflow: hidden;
  text-align: left;
  width: 100vw;
  box-sizing: border-box;
  padding: 19px 24px;
  margin-bottom: 10px;
}

.desc {
  text-align: left;
  font-family: PingFangSC-Regular;
  font-size: 4vw;
  line-height: 6.4vw;
  color: #000;
  margin-bottom: 1.9vw;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.tag-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.tag-list .tag-item {
  background-color: #f7f7f7;
  border-radius: 4px;
  padding: 1.4vw 2.9vw;
  font-size: 3.2vw;
  color: rgba(0, 0, 0, 0.5);
  margin-right: 1.6vw;
  margin-bottom: 1.6vw;
}

.content {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  position: relative;
  margin-bottom: 1.9vw;
  background-color: #e7e7e7;
  border-radius: 1.1vw;
}

.use {
  position: absolute;
  left: 4vw;
  bottom: 3.2vw;
  font-family: PingFangSC-Medium;
  font-size: 3.7vw;
  color: #ffffff;
}
.image-content {
  width: auto;
  max-height: 331px;
  max-width: 100%;
}
.video-image {
  width: 100%;
  height: 100%;
  max-height: 331px;
  max-width: 100%;
  object-fit: contain;
}

.mask {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  background-image: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0) 20%,
    rgba(0, 0, 0, 0) 80%,
    rgba(0, 0, 0, 0.5) 100%
  );
  width: 100%;
  height: 100%;
}

.collect {
  position: absolute;
  right: 2.4vw;
  top: 2.1vw;
  padding: 1.8vw 2.1vw;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 1.1vw;
  font-size: 3.2vw;
  overflow: hidden;
  color: #fff;
  display: flex;
  align-items: center;
}

.collect .iconfont {
  margin-right: 2.7vw;
  font-size: 3.6vw;
  color: #fff;
}

.collect .iconfont-active {
  color: #ff5a5a;
}
</style>
